import { render, staticRenderFns } from "./FormTag.vue?vue&type=template&id=43459b56"
import script from "./FormTag.js?vue&type=script&lang=js&external"
export * from "./FormTag.js?vue&type=script&lang=js&external"
import style0 from "./FormTag.vue?vue&type=style&index=0&id=43459b56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
